<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Xr0S9w/tc-custom/9781788634694.jpg?1717183254650" alt="This image is the cover for the book Family Ties, The Cornish Clay Sagas"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Family Ties, The Cornish Clay Sagas
      </h1>
      <p class="bookDescription body article font2">
        <p>  </p><p><b>Financial woes and a handsome stranger shake up one woman’s marriage in this heart-wrenching historical saga of love and family.</b></p><p> Ben was no longer the man that Morwen married. As financial troubles wrack the Killigrew household, the passion and strength of the man she loved so dearly seem to ebb away, leaving the clay works in an abject state. </p><p> Into this turbulent landscape arrives a dynamic stranger from America. With familial ties to the Killigrews, Randell Wainwright is determined to forge a stronger bond with one particular person—Morwen. In him, she sees everything her husband once was: compassionate, clear-sighted and virile. </p><p> As old hurts are renewed, as bitter family quarrels rage, and as blackmail and tragedy threaten the foundation of her home, Morwen struggles to save her name, and her family, from destruction. </p><b>Perfect for fans of Maureen Lee, Linda Finlay, and Lesley Pearse.</b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Rowena Summers
      </h2>
      
      <p class="authorDescription body article">Rowena Summers is the pseudonym of Jean Saunders. She was a British writer of romance novels since 1974, and wrote under her maiden name and her pseudonym, as well as the names Sally Blake and Rachel Moore. She was elected the seventeenth Chairman (1993–1995) of the Romantic Novelists’ Association, and she was the Vice-Chairman of the Writers’ Summer School of Swanwick. She was also a member of Romance Writers of America, Crime Writers’ Association and West Country Writers’ Association.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Canelo Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4262fb52